export const credentialsOfEmail = () => {
  const serviceID = "service_a2osglh";
  const salesTemplate = "template_4cms83z";
  const publicId = "1Wm9Yl4Czl_16yy-K";
  return { serviceID, salesTemplate, publicId };
};
